import { JsonObject, JsonProperty } from 'json2typescript';

@JsonObject('loan')
export class Loan {
  @JsonProperty('idObjetPret', String, true)
  public id = '';

  @JsonProperty('libObjetPret', String, true)
  public label = '';

  @JsonProperty('dureeMin', Number, true)
  public minDuration = 0;

  @JsonProperty('dureeMax', Number, true)
  public maxDuration = 100;

  @JsonProperty('montantMin', Number, true)
  public minAmount = 0;

  @JsonProperty('montantMax', Number, true)
  public maxAmount = 100000;
}
